'use client'

import React, {useEffect} from 'react'
import Script from 'next/script'
import {getInjection} from '@runlab/di'
import {
  BasketEventTypes,
  BasketUpdatedEvent,
  IEventBus,
  // OrderCreatedEvent,
  // OrderEventTypes,
  // ProductAddedToBasketEvent,
  // ProductRemovedFromBasketEvent,
} from '@/src/core/domain/events'
import {
  ProductDetailEventTypes,
  ProductListEventTypes,
  ViewCategoryEvent,
  ViewProductEvent,
} from '@/src/core/domain/events/product.events'
import {settings} from './settings'

export const disableAnalytic = settings.NEXT_PUBLIC_APP_ENV !== 'production'

export const Analythic = () => {
  useEffect(() => {
    if (disableAnalytic) {
      return
    }

    const eventBus = getInjection('IEventBus')

    // subscribePulseEvents(eventBus)
    subscribeMindboxEvents(eventBus)
  }, [])

  if (disableAnalytic) {
    return <></>
  }
  return (
    <>
      <Script
        id="ya-counter"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
      
            (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}
        m[i].l=1*new Date()
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document,'script','https://mc.yandex.ru/metrika/tag.js', 'ym')

    ym(17574757, 'init', {webvisor:true, clickmap:true, ecommerce:'dataLayer', referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true})
      `,
        }}
      />

      <noscript>
        <div>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="https://mc.yandex.ru/watch/17574757"
            style={{position: 'absolute', left: '-9999px'}}
            alt=""
          />
        </div>
      </noscript>

      {/*<Script*/}
      {/*  id="pulse-tracker"*/}
      {/*  type="text/javascript"*/}
      {/*  src="https://ping-services.ru/api/v1/track/site.js?site_id=7c6da24e-a176-4044-ab18-e865c545a0dc"*/}
      {/*  defer/>*/}

      <Script
        id="mindbox-script"
        dangerouslySetInnerHTML={{
          __html: `
      mindbox = window.mindbox || function() { mindbox.queue.push(arguments); };
      mindbox.queue = mindbox.queue || [];
      mindbox('create', {
        endpointId: 'runlab.Website'
      });
      
      var script = document.createElement("script");
      script.src = "https://api.s.mindbox.ru/scripts/v1/tracker.js";
      document.getElementsByTagName('head')[0].appendChild(script);
      
      `,
        }}></Script>
    </>
  )
}

// const subscribePulseEvents = (eventBus: IEventBus) => {
//   const pulseAnalytic = getInjection('PulseAnalytics')
//
//   eventBus.subscribe(BasketEventTypes.ProductAdded, (event: ProductAddedToBasketEvent) => {
//     pulseAnalytic.trackAddToCart(event)
//   })
//
//   eventBus.subscribe(BasketEventTypes.ProductRemoved, (event: ProductRemovedFromBasketEvent) => {
//     pulseAnalytic.trackRemoveToCart(event)
//   })
//
//   eventBus.subscribe(BasketEventTypes.BasketCleared, () => {
//     pulseAnalytic.trackClearCart()
//   })
//
//   eventBus.subscribe(OrderEventTypes.OrderCreated, (event: OrderCreatedEvent) => {
//     pulseAnalytic.trackOrderPlaced(event)
//   })
// }

const subscribeMindboxEvents = (eventBus: IEventBus) => {
  const mindboxAnalytic = getInjection('MindboxAnalytics')

  eventBus.subscribe(ProductDetailEventTypes.ViewProduct, (event: ViewProductEvent) => {
    mindboxAnalytic.viewProduct(event.payload!.id)
  })

  eventBus.subscribe(ProductListEventTypes.ViewCategory, (event: ViewCategoryEvent) => {
    mindboxAnalytic.viewCategory(event.payload!.id)
  })

  eventBus.subscribe(BasketEventTypes.OnUpdateBasket, (event: BasketUpdatedEvent) => {
    mindboxAnalytic.setBasket(event.payload!.basket)
  })
}
